import React from "react";
import { BookStore, Dispatcher } from "../../flux";
import { Isvg } from "../../components";
import PanelHeader from "./PanelHeader";

export default class FiguresOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      figureScale: 1.0,
      showMore: false,
      expandedText: false,
      showCaption: true,
      shortenedTitle: this.props.activeFigure.title,
      shortenedCaption: this.props.activeFigure.caption
    };

    this._moveImage = this._moveImage.bind(this);
    this._focusPanelNavigation = this._focusPanelNavigation.bind(this);
    this._blurPanelNavigation = this._blurPanelNavigation.bind(this);
    this._zoomIn = this._zoomIn.bind(this);
    this._zoomOut = this._zoomOut.bind(this);
    this._mouseUp = this._mouseUp.bind(this);
    this._mouseDown = this._mouseDown.bind(this);
    this._goToFigure = this._goToFigure.bind(this);
    this._onKeyUpGoToFigure = this._onKeyUpGoToFigure.bind(this);
    this._expandText = this._expandText.bind(this);
    this._shrinkText = this._shrinkText.bind(this);
    this._closeFiguresPanel = this._closeFiguresPanel.bind(this);
  }

  componentDidMount() {
    $(window).bind("mouseup touchup", this._mouseUp);
  }

  componentWillUnmount() {
    $(window).unbind("mouseup touchup", this._mouseUp);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.activeFigure !== nextProps.activeFigure) {
      this.setState({
        figureScale: 1.0,
        expandedText: false,
        showMore: false,
        shortenedTitle: nextProps.activeFigure.title,
        shortenedCaption: nextProps.activeFigure.caption
      });
    }
  }

  _closeFiguresPanel() {
    Dispatcher.emit(Dispatcher.TOGGLE_PANEL, "figures");
  }

  _onKeyUpGoToFigure(e) {
    if (e.keyCode === 13) {
      this._goToFigure(e);
    }
  }

  _goToFigure(e) {
    const book = BookStore.get(this.props.isbn);
    book.viewer.Book.goToFigure(this.props.activeFigure);
    if (Fraction.Helpers.isSmallScreen()) {
      Dispatcher.emit(Dispatcher.HIDE_ALL_PANELS);
    }
  }

  _expandText(e) {
    if (this.state.showMore) {
      this.setState({ expandedText: true });
    }
  }

  _shrinkText(e) {
    this.setState({ expandedText: false, showMore: false, showCaption: true });
  }

  _zoomIn() {
    this.setState(
      prevState => ({ figureScale: prevState.figureScale + 0.25 }),
      () => {
        this._updateZoomScroll();
      }
    );
    Fraction.Reporter.gaEvent("reader/panel/figures/zoom", "zoom-in");
  }

  _zoomOut() {
    this.setState(
      prevState => ({
        figureScale:
          prevState.figureScale <= 1 ? 1 : prevState.figureScale - 0.25
      }),
      () => {
        this._updateZoomScroll();
      }
    );
    Fraction.Reporter.gaEvent("reader/panel/figures/zoom", "zoom-out");
  }

  _updateZoomScroll(reverseScale) {
    const scrollLeft =
      (this.image.width + 24 - this.imageButton.clientWidth) / 2;
    const scrollTop = (this.image.height - this.imageButton.clientHeight) / 2;
    this.imageButton.scrollLeft = scrollLeft;
    this.imageButton.scrollTop = scrollTop;
  }

  _focusPanelNavigation() {
    this.setState({ panelNavigationFocused: true });
  }

  _blurPanelNavigation() {
    this.setState({ panelNavigationFocused: false });
  }

  _dragStart(e) {
    e.preventDefault();
  }

  _mouseDown(e) {
    this.setState({
      downX: e.clientX,
      downY: e.clientY,
      scrollX: $("#imageOverlay").scrollLeft(),
      scrollY: $("#imageOverlay").scrollTop()
    });
  }

  _moveImage(e) {
    if (this.state.downX) {
      $("#imageOverlay").scrollTop(
        this.state.scrollY + (this.state.downY - e.clientY)
      );
      $("#imageOverlay").scrollLeft(
        this.state.scrollX + (this.state.downX - e.clientX)
      );
    }
  }

  _mouseUp(e) {
    this.setState({
      downX: false,
      downY: false,
      scrollX: false,
      scrollY: false
    });
  }

  render() {
    const {
      caption,
      title,
      path,
      thumbnailURL,
      imageURL
    } = this.props.activeFigure;
    const figureBackgroundURL = path || thumbnailURL || imageURL;
    const { figureScale } = this.state;

    return (
      <div
        className={
          (Fraction.Helpers.isSmallScreen() ? "small " : "") + "figure-overlay"
        }
      >
        <PanelHeader
          headerClick={this.props.close}
          title={i18n.t("reader.panels.figures") || this.props.title}
          close={this.props._closeFiguresPanel}
        />
        <div className="overlay-zoom-buttons">
          <button
            className={
              "noButton overlay-decrease" +
              (figureScale === 1 ? " disabled" : "")
            }
            onClick={this._zoomOut}
          >
            <Isvg src="/img/decrease_sm.svg">NS</Isvg>
            <span className="offScreen">
              {i18n.t("reader.buttons.decrease-font")}
            </span>
          </button>
          <button className="noButton overlay-increase" onClick={this._zoomIn}>
            <Isvg src="/img/increase_sm.svg">NS</Isvg>
            <span className="offScreen">
              {i18n.t("reader.buttons.increase-font")}
            </span>
          </button>
        </div>
        <figure>
          <button
            ref={button => {
              this.imageButton = button;
            }}
            className="noButton"
            onClick={this._goToFigure}
          >
            <img
              id="fig-enlarge-img"
              ref={img => {
                this.image = img;
              }}
              src={figureBackgroundURL}
              style={{ width: `${figureScale * 100}%` }}
            />
            <figcaption className="offScreen">
              {title || i18n.t("reader.figures.no-title-provided")}
            </figcaption>
          </button>
          <figcaption
            className={Fraction.Helpers.isSmallScreen() ? "small" : ""}
          >
            <p className="title">{title}</p>
            {caption && (
              <p id="figure-caption" className="caption">
                {caption}
              </p>
            )}
          </figcaption>
        </figure>
        <div
          className="panel_navigation"
          style={{ opacity: this.state.panelNavigationFocused ? "1.0" : "" }}
        >
          <button
            className="noButton panel_previous"
            onClick={this.props.previous}
            onFocus={this._focusPanelNavigation}
            onBlur={this._blurPanelNavigation}
          >
            <Isvg src="/img/arrow_panel_previous.svg">NS</Isvg>
            <span className="offScreen">{i18n.t("base.previous")}</span>
          </button>
          <button
            className="noButton panel_next"
            onClick={this.props.next}
            onFocus={this._focusPanelNavigation}
            onBlur={this._blurPanelNavigation}
          >
            <Isvg src="/img/arrow_panel_next.svg">NS</Isvg>
            <span className="offScreen">{i18n.t("base.next")}</span>
          </button>
        </div>
      </div>
    );
  }
}
